var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComillas120X104(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157,
    height: 142,
    viewBox: "0 0 157 142",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4831_60600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8524 105.955L60.8588 105.95L60.8651 105.944C70.2384 97.4299 74.7507 83.7484 74.7507 65.2928V37.964C74.7507 31.6128 69.602 26.464 63.2507 26.464H38.0456C31.6943 26.464 26.5456 31.6128 26.5456 37.964V63.1592C26.5456 68.9838 31.2673 73.7055 37.0919 73.7055C41.1573 73.7055 44.2158 76.7789 43.6147 80.1722C42.9072 84.1666 41.238 87.4554 38.6233 90.0965C35.9969 92.7495 32.3488 94.8161 27.5917 96.2394C21.8023 97.9715 17.3038 103.594 18.6139 109.886C19.6509 114.866 24.1117 118.595 29.333 118.116C42.4817 116.909 53.0343 112.895 60.8524 105.955ZM125.602 90.9913L125.608 90.9857L125.614 90.9799C134.988 82.4658 139.5 68.7844 139.5 50.3288V23C139.5 16.6487 134.351 11.5 128 11.5H102.795C96.4436 11.5 91.2949 16.6487 91.2949 23V48.1951C91.2949 54.0197 96.0166 58.7415 101.841 58.7415C105.907 58.7415 108.965 61.8148 108.364 65.2082C107.657 69.2025 105.987 72.4913 103.373 75.1325C100.746 77.7854 97.0981 79.8521 92.341 81.2754C86.5516 83.0075 82.0531 88.6303 83.3632 94.9218C84.4002 99.9016 88.861 103.631 94.0823 103.152C107.231 101.945 117.784 97.9314 125.602 90.9913Z",
    stroke: "#3677DE",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4831_60600",
    x: 0.882324,
    y: 0,
    width: 156.118,
    height: 141.658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.278431 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4831_60600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4831_60600",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComillas120X104);
export default __webpack_public_path__ + "static/media/COMILLAS_120x104.c9a056b8c75a3f7b309b50d4272fa2a9.svg";
export { ForwardRef as ReactComponent };